import request from '@/utils/request';
export function templateList(data) {
  return request.post('admin/insurance-template/list', data);
}
//模版类型
export const typeList = [{
  name: '保险信息',
  id: 1
}, {
  name: '投保人',
  id: 2
}, {
  name: '被保险人',
  id: 3
}, {
  name: '受益人',
  id: 4
}, {
  name: '第一受益人',
  id: 5
}, {
  name: '第二受益人',
  id: 6
}, {
  name: '监护人',
  id: 7
}, {
  name: '保险扩展信息',
  id: 8
}];
//控件
export const controllist = [{
  name: '文本框',
  id: 'text'
}, {
  name: '下拉框',
  id: 'dropDownBox'
}, {
  name: '层级下拉框(国家)',
  id: 'dropDownBox(country)'
}, {
  name: '层级下拉框(地区)',
  id: 'dropDownBox(region)'
}, {
  name: '下拉框(自定义)',
  id: 'dropDownBox(custom)'
}, {
  name: '图片',
  id: 'IMG'
}, {
  name: '时间控件',
  id: 'time'
}, {
  name: '层级下拉框(职业)',
  id: 'profession'
}, {
  name: '层级下拉框(地区代码)',
  id: 'dropDownBox(region.code)'
}];
export function addTemplate(data) {
  return request.post('admin/insurance-template/store', data);
}
export function templateDetail(data) {
  return request.post('admin/insurance-template/detail', data);
}
export function editTemplate(data) {
  return request.post('admin/insurance-template/edit', data);
}
export function templateStatus(data) {
  return request.post('admin/insurance-template/status', data);
}
export function delTemplate(data) {
  return request.post('admin/insurance-template/delete', data);
}